// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".article-avatar:not(:first-child){margin-left:-10px}.article-avatar:not(:first-child) img{-webkit-mask:radial-gradient(circle 24px at -10px 50%,transparent 99%,#fff 100%);mask:radial-gradient(circle 24px at -10px 50%,transparent 99%,#fff 100%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
